import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { OwlOptions, SlidesOutputData } from 'ngx-owl-carousel-o';
import { first } from 'rxjs';

import { InitialBaniSubSection } from 'src/app/core/constants';
import {
  AllBaniData,
  BaniDetails,
  BaniInfo,
  BaniSection,
} from 'src/app/core/models';
import { ModalVideoComponent } from '../common/modal-video/modal-video.component';
import { DashboardService } from 'src/app/services/dashboard.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-bani-dashboard',
  templateUrl: './bani-dashboard.component.html',
  styleUrls: ['./bani-dashboard.component.scss'],
})
export class BaniDashboardComponent implements OnInit {
  baniData: BaniDetails[] = [];
  customOptions: OwlOptions = {
    // items: 1,
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    autoHeight: false,
    autoplay: true, // Enable autoplay (optional)
    autoplayTimeout: 50000, // Autoplay interval in milliseconds (optional)
    autoplaySpeed: 1800,
    autoplayHoverPause: true,
    dots: false,
    nav: true,
    navSpeed: 1000,
    navText: ['&#8249', '&#8250;'],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      760: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  };
  baniVideoUrls = [];
  activeSlides: SlidesOutputData | undefined;
  isHandsetPortrait: boolean = false;
  baniInfo?: BaniInfo;
  baniName?: string;
  baniIntroduction: string = '';
  isBaniDataLoading: boolean = false;
  areSeeMoreDotsNeeded: boolean = false;
  isBaniIntroductionLoading: boolean = false;
  allBaniDashboardData: AllBaniData = {} as AllBaniData;
  txtColor:any='';
  constructor(
    private dashboardService: DashboardService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private router: Router,
    private utils: UtilsService,
  ) {}

  ngOnInit(): void {
    let baniCode = this.route.snapshot.paramMap.get('baniCode');

    this.fetchBaniDashboardData(baniCode);
  }

  fetchImageThumbnail(baniItem: any) {
    if (baniItem.BaniVideoURL) {
      return this.utils.fetchImageThumbnail(baniItem.BaniVideoURL);
    } else if (baniItem.ThumbnailImageURL){
      return baniItem.ThumbnailImageURL;
    }else{
      return '/assets/images/mediaPlaceholder.webp';
    
    }
  }

  fetchBaniVideoThumbnailImage(baniItem: any, video: any) {    
    if (video) {
      return this.utils.fetchImageThumbnail(video);
    } else if (baniItem.ThumbnailImageURL){
      return baniItem.ThumbnailImageURL;
    } else{
      return '/assets/images/mediaPlaceholder.webp';    
    }
  }

  fetchBaniDashboardData(baniCode: string | null) {
    this.isBaniDataLoading = true;
    this.dashboardService
      .fetchBaniDashboardData(baniCode)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.isBaniDataLoading = false;
          this.allBaniDashboardData = res?.value?.length ? res.value[0] : {};
          
          // for Bani Video Urls
          const banivideourls= this.allBaniDashboardData.BaniVideoURL;
          const videourlArray:any =  this.convertBaniVideoUrlsToArray(banivideourls);
          this.baniVideoUrls = videourlArray;
          console.log(this.baniVideoUrls)

          // sort sections in descreasing increasing order by SectionSequence
          this.allBaniDashboardData.Sections =
            this.allBaniDashboardData.Sections.sort(
              (a: any, b: any) =>
                parseFloat(a.SectionSequence) - parseFloat(b.SectionSequence)
            );
          if(this.allBaniDashboardData.ShowSubSection){
            this.allBaniDashboardData.Sections[0].SubSection =
            this.allBaniDashboardData.Sections[0].SubSection.sort(
              (a: any, b: any) =>
                parseFloat(a.SubSectionSequence) - parseFloat(b.SubSectionSequence)
            );
          }
          // this.metaService.updateTag({ property:'og:image', content:this.allBaniDashboardData?.BaniImageURL});
          // this.metaService.updateTag({ property:'og:description', content: this.allBaniDashboardData?.MetaTagDescription});

          this.baniIntroduction = this.allBaniDashboardData.Introduction;
        },
        error: (err) => {
          // console.log('error in fetching bani dashboard data ', err);
        },
      });
  }

  convertBaniVideoUrlsToArray(urlsString: string): string[] {
    // Remove any leading or trailing whitespace
    urlsString = urlsString.trim();
    // Split the string into an array using comma (,) as the delimiter
    return urlsString.split(',');
  }

  showSmallerSubSectionSString(subSections: any) {
    // pick subsectioncontent of Overview subsection
    let overviewSubSectionData = subSections.find((subSectionData: any) => {
      return subSectionData.SubSectionSequence === 1;
    });
    // Overview doesnt exist in case of invocation
    // in that case pick Invocation's own SubSectionContent
    if (!overviewSubSectionData) {
      overviewSubSectionData = subSections.find((subSectionData: any) => {
        return subSectionData.SubSectionSequence === 2;
      });
    }

    return this.utils.showSmallerString(
      overviewSubSectionData.Overview
    );
  }

  subSectionString(overview: any){
    return this.utils.showSmallerString(
      overview
    );
  }

  showSmallerIntroductionString(descriptionText: string | undefined) {
    this.areSeeMoreDotsNeeded =
      this.utils.calculateTextLength(descriptionText) > 750 ? true : false;

    return this.utils.showSmallerIntroductionString(descriptionText);
  }

  openVideoPopup(videoURL: string | undefined, event?:any): void {
    event.preventDefault();
    if (videoURL) {
      this.dialog.open(ModalVideoComponent, {
        data: { videoURL },
      });
    }
  }

  openBaniSubDetails(baniDetails: BaniSection) {
    // for section 0, which is the invocation, first subsectionsequence is always 2, else for
    // other sections, first subsectionsequence is always 1
    this.router.navigate([
      '/bani/details',
      this.allBaniDashboardData.BaniCode,
      baniDetails.SectionSequence,
      baniDetails.SectionSequence ? InitialBaniSubSection : 2,
    ]);
  }

  openBaniSubDetailsLink(baniDetails: BaniSection) {

    return this.router.createUrlTree([
      '/bani/details',
      this.allBaniDashboardData.BaniCode,
      baniDetails.SectionSequence,
      baniDetails.SectionSequence ? InitialBaniSubSection : 2,
    ]);
  }

  openBaniSubSectionDetails(bani: any){
    this.router.navigate([
      '/bani/details',
      this.allBaniDashboardData.BaniCode,
      this.allBaniDashboardData.Sections[0].SectionSequence,
      bani.SubSectionSequence,
    ]);
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
    setTimeout(() => {
      this.customOptions = { ...this.customOptions };
    }, 200);
  }

  goToIntroductionDetails() {
    this.router.navigate([
      '/bani/introduction',
      this.allBaniDashboardData.BaniId,
      'Introduction',
    ]);
  }

  goToIntroductionDetailsLink() {
    return this.router.createUrlTree([
      '/bani/introduction',
      this.allBaniDashboardData.BaniId,
      'Introduction',
    ]);
  }

  getBackgroundImageUrl(img:string){
      //img= typeof img === 'string' ? img.trim() : '';
      img = img?.trim() || '';
      if(img != ''){
        this.txtColor = 'white';
        return `url('${img}')`;
      }else{
        this.txtColor = 'black';
        let imgUrl = '/assets/images/carousel-background.webp';
        return `url(${imgUrl})`;
      } 
  }

  getBackgroundImageUrlShabd(img:string){
    
      //img= typeof img === 'string' ? img.trim() : '';
      img = img?.trim() || '';
      if(img != ''){
        return `url('${img}')`;
      
      }else{
        let imgUrl = '/assets/images/mediaPlaceholder.webp';
        return `url(${imgUrl})`;
        
      } 
  }

}
